<template>
  <b-container class="p-0" fluid="true" style="overflow: auto; display: inline-block;">
    <b-row no-gutters>
      <b-col class="pl-2">
        <pre style="padding: 5px;" v-html="data"></pre>
      </b-col>
    </b-row>
  </b-container>
</template>
<script>
import Activity from "@/activity/Activity";

import hljs from 'highlight.js/lib/core';
import 'highlight.js/styles/github.css';
import xml from 'highlight.js/lib/languages/xml';

hljs.registerLanguage('xml', xml);

export default {
  name: "BrandingProductInfo",
  components: {},

  async mounted() {
    this.data = hljs.highlight(this.brandingProductInfo, {language: 'xml'}).value;
  },

  methods: {
    ...Activity.methods,

    getTitle() {
      return $tr('brandingProduct.info.product.data','Product Data for Branding');
    },
  },

  props: {
    brandingProductInfo: {default: null},
  },


  data: () => ({
    data: "",
  }),

}
</script>
